import classnames from 'classnames'

export interface DayProps {
  key?: number
  day?: number
  disabled?: boolean
  onClick?: (day: number) => void
  rangeStart?: boolean
  rangeMiddle?: boolean
  rangeEnd?: boolean
  selected?: boolean
  today?: boolean
}

export const Day = ({
  onClick,
  selected,
  today,
  rangeStart,
  rangeMiddle,
  rangeEnd,
  day,
  key,
  disabled
}: DayProps) => {
  const isClickable = typeof onClick === 'function' && typeof day === 'number'
  return (
    <div
      className={classnames('a-day', {
        'a-day--selected': selected,
        'a-day--today': today,
        'a-day--range-start': rangeStart,
        'a-day--range-middle': rangeMiddle,
        'a-day--range-end': rangeEnd,
        'a-day--disabled': disabled
      })}
      key={key}
      onClick={isClickable ? () => onClick(day) : undefined}
    >
      {day}
    </div>
  )
}
